document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.exoride [data-animate]');
  const colorPickers = document.querySelectorAll('[data-exoride-color-picker]');

  colorPickers.forEach((picker) => {
    const image = picker.querySelector('[data-exoride-color-image]');
    const options = picker.querySelectorAll('.exoride__color-option');

    if (!image || !options.length) return;

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const nextImage = option.dataset.image;
        const nextAlt = option.dataset.alt;

        if (!nextImage) return;

        image.src = nextImage;
        if (nextAlt) image.alt = nextAlt;

        options.forEach((item) => {
          item.classList.toggle('is-active', item === option);
          item.setAttribute('aria-pressed', item === option ? 'true' : 'false');
        });
      });
    });
  });

  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14 });

  items.forEach((item) => observer.observe(item));
});
